export const exteriorPaintRegions = [
  'walls',
  'trim',
  // TODO: restore this after adding support for scrolling the paint region tabs
  // 'fence',
  'door',
  'garage_door',
  'shutter',
] as const;

export const interiorPaintRegions = ['walls', 'cabinet', 'ceiling'] as const;
export const paintRegions = [
  ...exteriorPaintRegions,
  ...interiorPaintRegions,
] as const;

export const interiorMaterialRegions = ['floor', 'cabinet'] as const;
export const exteriorMaterialRegions = [
  'walls',
  'roof',
  'windows',
  'garage_door',
] as const;
export const materialRegions = [
  ...interiorMaterialRegions,
  ...exteriorMaterialRegions,
] as const;

export type PaintRegion = (typeof paintRegions)[number];
export type MaterialRegion = (typeof materialRegions)[number];
export type MaterialRegionOrPaint = MaterialRegion | 'paint';

export type Region = PaintRegion | MaterialRegion;

export interface CustomizePaint {
  type: 'paint';
  region: PaintRegion;
}

export interface CustomizeMaterial {
  type: 'material';
  region: MaterialRegion;
}

export interface PartnerCategoryConfiguration {
  /**
   * The variation facet `name` to use to populate the `palettes` field and
   * separate products into palettes in the edit experience
   */
  paletteFacet?: string;
  /**
   * The variation facet to use as the primary label anywhere we display a
   * product or list of products. This defaults to `name` on the variation.
   */
  primaryLabelFacet?: string;
  /**
   * The variation facet to use as the secondary label anywhere we display a
   * product or list of products. For paint colors, this defaults to the
   * manufacter (`product.provider.name`) on the product (not the variation).
   */
  secondaryLabelFacet?: string;
  /**
   * The localization key to use any time we're displaying the primary and
   * secondary label on the same line. If this isn't provided, we'll display
   * only the primary label in those cases.
   */
  i18nKeyPrimarySecondaryLabel?: string;
}

export interface PartnerCustomizePaint
  extends CustomizePaint,
    PartnerCategoryConfiguration {}

export interface PartnerCustomizeMaterial
  extends CustomizeMaterial,
    PartnerCategoryConfiguration {}

export type CustomizationCategory = CustomizePaint | CustomizeMaterial;
export type PartnerCustomizationCategory =
  | PartnerCustomizePaint
  | PartnerCustomizeMaterial;

export type CustomizationType = CustomizationCategory['type'];

export const isCategoryEqual = (
  a: CustomizationCategory,
  b: CustomizationCategory,
) => {
  if (a.type === 'paint' && b.type === 'paint') return true;
  if (a.type === 'material' && b.type === 'material')
    return a.region === b.region;

  return false;
};
